var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"champ",class:{field_edition: _vm.edition},attrs:{"contenteditable":_vm.edition,"placeholder":_vm.placeholder}},[_vm._v(_vm._s(_vm.data))])
}
var staticRenderFns = []

export { render, staticRenderFns }